var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.socials),function(socialNetwork){return _c('v-btn',{key:socialNetwork.icon,staticClass:"mx-4 secondary--text",attrs:{"icon":"","href":socialNetwork.url,"target":"_blank","x-small":!_vm.isMobile}},[_c('v-icon',[_vm._v(" "+_vm._s(socialNetwork.icon)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }